"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactTextareaAutosize = _interopRequireDefault(require("react-textarea-autosize"));

var _DarkBoxInput = require("./DarkBoxInput.style");

var TextArea = function TextArea(props) {
  return _react.default.createElement("textarea", props);
};

function DarkBoxInputMultiline(props) {
  var className = props.className,
      autosize = props.autosize,
      rest = (0, _objectWithoutProperties2.default)(props, ["className", "autosize"]);
  var Input = autosize ? _reactTextareaAutosize.default : TextArea;
  return _react.default.createElement(Input, (0, _extends2.default)({
    className: (0, _classnames.default)('box-input-multiline', _DarkBoxInput.boxInput, className)
  }, rest));
}

DarkBoxInputMultiline.defaultProps = {
  className: '',
  autosize: false
};
var _default = DarkBoxInputMultiline;
exports.default = _default;